"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptInvitePage = exports.AcceptInvitePageConfig = void 0;
const centered_card_1 = require("../components/centered.card/centered.card");
const accept_invite_1 = require("../modules/user/accept.invite");
const accept_invite_ctrl_1 = require("../modules/user/accept.invite.ctrl");
const services_1 = require("../services");
const page_1 = require("./page");
const PARAM_INVITE_TOKEN = 'inviteToken';
exports.AcceptInvitePageConfig = {
    type: 'internal',
    name: page_1.IkePageName.acceptInvite,
    path: ['/accept-invite/:inviteToken', '/accept-invite/:inviteToken/:page'],
    auth: { required: false },
    layout: { nav: false, banner: false }
};
class AcceptInvitePage extends page_1.IkePage {
    constructor() {
        super(exports.AcceptInvitePageConfig);
        this.name = 'AcceptInvite';
    }
    init() {
        const inviteToken = services_1.Services.Route.params.get(PARAM_INVITE_TOKEN);
        const ctrl = new accept_invite_ctrl_1.AcceptInviteCtrl(inviteToken);
        this.component = new accept_invite_1.AcceptInviteComponent(ctrl);
        this.reaction(() => ctrl.inviteMethod, value => services_1.Services.Route.setParam('page', value, true));
        const params = services_1.Services.Route.params.toJSON();
        const currentMethod = params.page;
        ctrl.setInviteMethod(currentMethod || accept_invite_ctrl_1.InviteMethod.Undecided);
    }
    get nodes() {
        if (this.component == null) {
            this.init();
        }
        return centered_card_1.CenteredCard.view(this.component.view());
    }
}
exports.AcceptInvitePage = AcceptInvitePage;
//# sourceMappingURL=accept.invite.page.js.map